

















































import {Component, Provide, Vue, Prop, Watch} from 'vue-property-decorator';
/*pagination component for list
  prop: totalData = length of list
  emit: starting point and ending point for view
*/
@Component
export default class Paginition extends Vue {
  @Prop() totalData!: number;
  @Prop({default: 5}) parentNumberOfRows!: number;
  numberOfRows = this.parentNumberOfRows;
  startingPoint: number = 0;
  endingPoint: number = this.totalData < 5 ? this.totalData : 5;
  currentStartingPoint: number = this.totalData ? 1 : 0;
  currentEndingPoint: number = this.endingPoint;
  paginationPoints = {
    startingPoint: this.currentStartingPoint,
    endingPoint: this.currentEndingPoint,
  };
  disableNextButton = this.totalData <= this.numberOfRows ? true : false;
  disablePreviousButton = true;
  disableColorButton = '#ffffff';
  differencePagination: number = 5;

  // get numberOfRows() {
  //   return this.parentNumberOfRows;
  // }

  // set numberOfRows(value) {
  //
  //   if(Number(value)!==this.parentNumberOfRows) {

  //     this.numberOfRows=value
  //   }
  // }

  //pagination list size change listener
  @Watch('totalData', {immediate: true})
  dataChanged(newValue: number, oldValue: number) {
    this.endingPoint = newValue;
    this.numberOfRows = Number(this.numberOfRows);
    if (newValue === 0) {
      this.noData();
    } else {
      const diff = newValue - oldValue;
      //fiter reset to page one if change is huge
      if (diff > 1 || diff < -1) {
        this.switchToFirstPage();
      } else if (diff === -1) {
        //single operation if one data deleted
        if (this.currentStartingPoint === this.currentEndingPoint) {
          this.previousPage();
        } else {
          if (this.currentEndingPoint > this.totalData) this.currentEndingPoint -= 1;
          this.disableNextButton = this.totalData <= this.currentEndingPoint ? true : false;
          this.paginationPoints = {
            startingPoint: this.currentStartingPoint,
            endingPoint: this.currentEndingPoint,
          };
        }
      } else if (diff === 1) {
        this.paginationPoints = {
          startingPoint: 1,
          endingPoint: 1,
        };
        this.currentStartingPoint = 1;
        this.currentEndingPoint = 1;
      }
    }
  }

  //emit if pagination points changes
  @Watch('paginationPoints')
  emitData(newValue: any, oldValue: any) {
    this.$emit('paginitionParams', newValue.startingPoint, newValue.endingPoint, this.numberOfRows);
  }

  @Watch('numberOfRows', {immediate: true})
  rowChanged(newValue: number, oldValue: number) {
    this.switchToFirstPage();
  }

  nextPage(e = null) {
    if (e) e.preventDefault();
    this.disablePreviousButton = false;
    this.numberOfRows = Number(this.numberOfRows);
    if (this.numberOfRows < this.totalData) {
      this.startingPoint += this.numberOfRows;
      this.differencePagination = this.totalData - this.startingPoint;
      let hasMoreData = this.differencePagination > this.numberOfRows;
      this.endingPoint = hasMoreData ? this.startingPoint + this.numberOfRows : this.totalData;
      this.disableNextButton = !hasMoreData;
    } else {
      this.endingPoint = this.totalData;
      this.disableNextButton = true;
    }
    this.currentEndingPoint = this.endingPoint;
    this.currentStartingPoint = this.startingPoint + 1;
    this.paginationPoints = {
      startingPoint: this.currentStartingPoint,
      endingPoint: this.currentEndingPoint,
    };
  }

  previousPage(e = null) {
    if (e) e.preventDefault();
    this.differencePagination = this.totalData - this.startingPoint;
    this.numberOfRows = Number(this.numberOfRows);
    if (this.startingPoint === this.numberOfRows) {
      this.startingPoint = 0;
      this.disablePreviousButton = true;
      this.currentStartingPoint = 1;
    } else {
      this.startingPoint -= this.numberOfRows;
      this.currentStartingPoint = this.startingPoint + 1;
    }
    this.disableNextButton = false;
    let hasMoreData = this.endingPoint >= this.totalData;
    this.endingPoint = hasMoreData
      ? (this.endingPoint -= this.differencePagination)
      : (this.endingPoint -= this.numberOfRows);
    this.currentEndingPoint = this.endingPoint;
    this.disableNextButton = this.currentEndingPoint === this.totalData;
    this.paginationPoints = {
      startingPoint: this.currentStartingPoint,
      endingPoint: this.currentEndingPoint,
    };
  }

  reset() {
    this.switchToFirstPage();
  }

  switchToFirstPage() {
    if (this.totalData > 0) {
      this.numberOfRows = Number(this.numberOfRows);
      this.startingPoint = 0;
      this.currentStartingPoint = 1;
      this.currentEndingPoint = this.numberOfRows > this.totalData ? this.totalData : this.numberOfRows;
      this.paginationPoints = {
        startingPoint: this.currentStartingPoint,
        endingPoint: this.currentEndingPoint,
      };
      this.disableNextButton = this.totalData <= this.numberOfRows ? true : false;
      this.disablePreviousButton = true;
    } else {
      this.noData();
    }
  }

  noData() {
    this.disableNextButton = true;
    this.disablePreviousButton = true;
    this.startingPoint = 0;
    this.currentStartingPoint = 0;
    this.currentEndingPoint = 0;
    this.paginationPoints = {startingPoint: 0, endingPoint: 0};
  }

  onColorChange(buttonDiasbled: boolean) {
    let colors = {
      enableColor: '#ffffff',
      disableColor: '#808080',
    };
    const color = buttonDiasbled ? colors.disableColor : colors.enableColor;
    return 'color:' + color;
  }
}
